import { z } from 'zod';
import { requiredString } from '../helpers';
export const Chat_Handoff_1_ConfigValidator = z.object({
    destinationAgentId: requiredString('Destination agent is required')
});
//# sourceMappingURL=chat-handoff-1.js.map